// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"01410108","165":"e43d414c","167":"ac91b2e5","236":"6e871032","626":"b2683a08","629":"2127a3b5","671":"7b420d0e","715":"e18e291e","718":"55d1214f","902":"e2855677","906":"906aaa72"}[chunkId] + ".chunk.js";
};